import styled from "@emotion/styled";
import Header from "Components/Header";
import { FC } from "react";
import { useNavigate } from "react-router-dom";

const Content = styled.div`
  height: calc(100vh - 180px);
  display: flex;
  justify-content: center;
  padding-top: 100px;
`;

const Settings: FC = () => {
  const navigate = useNavigate();
  const onSearch = (query: string) => {
    if (query === '') {
      navigate('/categories');
      return;
    }
    navigate(`/search?q=${query}`);
  };
  return (
    <div>
      <Header onSearch={onSearch} />
      <Content>
      </Content>
    </div>
  );
};

export default Settings;
